import React, { useState } from "react";
import { PropTypes } from "prop-types";

import { Tooltip } from "widgets/feedback";

import { MAX_CONTENT_LENGTH } from "@/common/filepicker/filepicker.constant";

import styles from "./styles.css";

export function FileToolTip(props) {
  const { children, isFileSelected, isError, isFolder, customClass } = props;
  const [showToolTip, setTooltipVisibility] = useState(false);

  const onMouseOver = (content) => {
    if (content.length < MAX_CONTENT_LENGTH) {
      setTooltipVisibility(true);
    }
  };

  const onMouseLeave = () => setTooltipVisibility(false);

  return (
    <Tooltip content={showToolTip || isError ? null : children}>
      <div
        className={isFolder ? `ellipsis` : ""}
        onMouseOver={() => onMouseOver(children)}
        onMouseLeave={onMouseLeave}
      >
        <p
          className={`
            ${isFileSelected ? styles.selectedFileText : null}
            ${
              isError
                ? `small ${styles.errorMessage}`
                : `${customClass} ellipsis`
            }`}
        >
          {children}
        </p>
      </div>
    </Tooltip>
  );
}

FileToolTip.propTypes = {
  children: PropTypes.node,
  isFileSelected: PropTypes.bool,
  isError: PropTypes.bool,
  isFolder: PropTypes.bool,
  customClass: PropTypes.string
};
